import { WarningSymbol } from '@/components/warning/WarningSymbol';
import { strings } from '@/services/translation/strings';
import { SeverityType, severityTypeToColor } from '@/services/warnings/warningDefinitions';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { FC, PropsWithChildren, Suspense } from 'react';

interface Props extends PropsWithChildren {
  severity: SeverityType;
  parentContainerId: string;
}

export const WarningPopup: FC<Props> = ({ children, severity }) => {
  const color = severityTypeToColor(severity);

  return (
    <RadixTooltip.Provider delayDuration={100}>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger>
          <WarningSymbol className="w-8 h-8" severity={severity}/>
        </RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <Suspense>
            <RadixTooltip.Content
              side={'right'}
              sideOffset={5}
              className="z-[1000] bg-white border rounded-md p-3 w-[350px] shadow-lg"
            >
              <div className="flex items-center space-x-3 mb-2 border-b pb-2">
                <WarningSymbol className="h-6 w-6" severity={severity}/>
                <div className="font-bold text-lg" style={{ color: color }}>
                  {severity === SeverityType.CRITICAL
                    ? strings.common.severity.critical
                    : strings.common.severity.warning}
                </div>
              </div>
              <div className="space-y-1.5">{children}</div>
            </RadixTooltip.Content>
          </Suspense>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};
